<template>
    <div>
        <!-- 这里的权限通过后端来控制是否显示 -->
        <transition>
            <el-menu class="Layout-Nav" :collapse="NavShow"
                     background-color="#0074C7" text-color="#ffffff"
                     active-text-color="#ffffff"
                     :router="true" :default-active="path" v-cloak>
                <el-menu-item index="/dashboard">
                    <i class="icon-shouye iconsize"></i>
                    <span slot="title" style="font-size:14px">{{$t('lang.menu.Home')}}</span>
                </el-menu-item>
                <!--设备列表-->
                <el-submenu index="1" v-if="device.parentId">
                    <template slot="title">
                        <i class="icon-huabanfuben iconsize"></i>
                        <span slot="title">{{$t('lang.menu.device')}}</span>
                    </template>
                        <el-menu-item index="/device/devicelist" v-if="arr.indexOf(14)!=-1" class="Menu-Group">
                        {{$t('lang.menu.devicelist')}}</el-menu-item>
                        <el-menu-item index="/device/groupinglist" v-if="arr.indexOf(10)!=-1" class="Menu-Group">
                        {{$t('lang.menu.groupinglist')}}</el-menu-item>
                        <el-menu-item index="/device/unusuallist" v-if="arr.indexOf(92)!=-1" class="Menu-Group">
                        {{$t('lang.menu.unusuallist')}}</el-menu-item>
                        <el-menu-item index="/device/hangingDevice" class="Menu-Group"  v-if="arr.indexOf(198)!=-1">
                            <span slot="title" style="font-size:14px">{{$t('lang.menu.HangingDevice')}}</span>
                        </el-menu-item>
                        <el-menu-item index="/device/terminalList" class="Menu-Group"  v-if="arr.indexOf(276)!=-1">
                            <span slot="title" style="font-size:14px">{{$t('lang.router.TerminalList')}}</span>
                        </el-menu-item>
                </el-submenu>
                <!--资源管理-->
                <el-submenu index="2" v-if="resource.parentId">
                    <template slot="title">
                        <i class="icon-wenjian iconsize"></i>
                        <span slot="title">{{$t('lang.menu.resource')}}</span>
                    </template>
                    <el-menu-item index="/resource/configuration" v-if="arr.indexOf(93)!=-1" class="Menu-Group">
                    {{$t('lang.menu.configuration')}}</el-menu-item>
                    <el-menu-item index="/resource/configurationlist" v-if="arr.indexOf(34)!=-1" class="Menu-Group">
                    {{$t('lang.menu.configurationlist')}}</el-menu-item>
                    <el-menu-item index="/resource/firmware" v-if="arr.indexOf(93)!=-1" class="Menu-Group">
                    {{$t('lang.menu.firmware')}}</el-menu-item>
                </el-submenu>
                <!--故障管理-->
                <el-submenu index="3" v-if="alarmMsg.parentId">
                    <template slot="title">
                        <i class="icon-xitongguzhang iconsize"></i>
                        <span slot="title">{{$t('lang.menu.alarmMsg')}}</span>
                    </template>
                    <el-menu-item index="/alarmMsg/historywarn" v-if="arr.indexOf(31)!=-1" class="Menu-Group">
                    {{$t('lang.menu.historywarn')}}</el-menu-item>
                    <el-menu-item index="/alarmMsg/warnconfiguration" v-if="arr.indexOf(32)!=-1" class="Menu-Group">
                    {{$t('lang.menu.warnconfiguration')}}</el-menu-item>
                    <el-menu-item index="/alarmMsg/currenttimewarn" v-if="arr.indexOf(33)!=-1" class="Menu-Group">
                    {{$t('lang.menu.currenttimewarn')}}</el-menu-item>      
                </el-submenu>
                <!--统计报表-->
                <el-submenu index="4" v-if="graphs.parentId">
                    <template slot="title">
                        <i class="icon-tongji iconsize"></i>
                        <span slot="title">{{$t('lang.menu.graphs')}}</span>
                    </template>
                    <el-menu-item index="/graphs/onlinerate" v-if="arr.indexOf(80)!=-1" class="Menu-Group">
                    {{$t('lang.menu.onlinerate')}}</el-menu-item>
                    <el-menu-item index="/graphs/flowstatistics" v-if="arr.indexOf(81)!=-1" class="Menu-Group">
                    {{$t('lang.menu.flowstatistics')}}</el-menu-item>
                    <el-menu-item index="/graphs/signalstatistics" v-if="arr.indexOf(82)!=-1" class="Menu-Group">
                    {{$t('lang.menu.signalstatistics')}}</el-menu-item>
                    <el-menu-item index="/graphs/softwareversion" v-if="arr.indexOf(83)!=-1" class="Menu-Group">
                    {{$t('lang.menu.Softwareversion')}}</el-menu-item>
                </el-submenu>
                <!--任务管理-->
                <el-submenu index="5" v-if="task.parentId">
                    <template slot="title">
                        <i class="icon-renwu iconsize"></i>
                        <span slot="title">{{$t('lang.menu.task')}}</span>
                    </template>
                    <el-menu-item index="/task/softwarepackage" v-if="arr.indexOf(76)!=-1" class="Menu-Group">
                    <!-- <span class="Layout-Nav-Irem-Icon">•</span> -->
                    {{$t('lang.menu.softwarepackage')}}</el-menu-item>
                    <el-menu-item index="/task/upgrade" v-if="arr.indexOf(77)!=-1" class="Menu-Group">
                    <!-- <span class="Layout-Nav-Irem-Icon">•</span> -->
                    {{$t('lang.menu.upgrade')}}</el-menu-item>
                    <el-menu-item index="/task/advertising" v-if="arr.indexOf(78)!=-1" class="Menu-Group">
                    <!-- <span class="Layout-Nav-Irem-Icon">•</span> -->
                    广告</el-menu-item>
                </el-submenu>
                <!--系统管理-->
                <el-submenu index="6" v-if="system.parentId&&user_iscustomer&&user_ctid">
                    <template slot="title">
                        <i class="icon-system-copy iconsize"></i>
                        <span slot="title">{{$t('lang.menu.system')}}</span>
                    </template>
                    <el-menu-item index="/system/authoritymanagement" v-if="arr.indexOf(26)!=-1" class="Menu-Group">
                    <!-- <span class="Layout-Nav-Irem-Icon">•</span> -->
                    {{$t('lang.menu.Authoritymanagement')}}</el-menu-item>
                    <el-menu-item index="/system/customermanagement" v-if="arr.indexOf(89)!=-1"
                    class="Menu-Group">
                    <!-- <span class="Layout-Nav-Irem-Icon">•</span> -->
                    {{$t('lang.menu.customermanagement')}}</el-menu-item>
                    <el-menu-item index="/system/usercontrol" v-if="arr.indexOf(13)!=-1" class="Menu-Group">
                    <!-- <span class="Layout-Nav-Irem-Icon">•</span> -->
                    {{$t('lang.menu.usercontrol')}}</el-menu-item>
                    <el-menu-item index="/system/remoteservice" v-if="arr.indexOf(174)!=-1"
                    class="Menu-Group">
                    {{$t('lang.menu.RemoteService')}}</el-menu-item>
                    <el-menu-item index="/system/parametermanagement" v-if="arr.indexOf(167)!=-1"
                    class="Menu-Group">{{$t('lang.menu.parametermanagement')}}</el-menu-item>
                     <el-menu-item index="/system/printerdriver" class="Menu-Group" v-if="arr.indexOf(200)!=-1">
                        <span slot="title" style="font-size:14px">{{$t('lang.menu.PrinterDriver')}}</span>
                    </el-menu-item>
                </el-submenu>
                        <!-- 日志管理 -->
                <el-menu-item index="/logManagement" v-if="user_id == 1">
                    <i class="el-icon-tickets iconsize" style="font-size: 14px;width: 14px;"></i>
                    <span slot="title" style="font-size:14px">操作日志</span>
                </el-menu-item>
            </el-menu>
            </transition>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {UserGetMenu} from '@/api/nav'
    import {setMenu, getMenu} from '@/cookie/cookie'
    import { getuser_iscustomer,getuser_ctid,getuser_id } from '@/localStorage/localStorage'

    //递归筛选函数
    var findInObject = function (dataObj, key) {
        let arr = [];        
        if (typeof dataObj !== 'object') return arr;
        for (let prop in dataObj) {          
            if (prop == key) {
                arr.push(dataObj[key]);
            } else {
                if (Array.isArray(dataObj[prop])) {
                    dataObj[prop].forEach((item) => {
                        arr = arr.concat(findInObject(item, key))
                    });
                }
            }
        }
       
        
        return arr;
    }
    export default {
        data() {
            return {
                //权限数据
                navlist: [],
                //设备管理
                device: {},
                //故障管理
                alarmMsg: {},
                //统计报表
                graphs: {},
                //资源管理
                resource: {},
                //任务管理
                task: {},
                //系统管理
                system: {},
                //监听页面高度达到侧边栏自适应高度,
                arr: [],
                path: this.$route.path,
                navwidth: 12,
                user_iscustomer:getuser_iscustomer(),
                user_ctid:getuser_ctid(),
                user_id:getuser_id(),
            };
        },
        mounted() {
            UserGetMenu(0).then((res) => { 
                    this.arr = findInObject(res.data, 'sonId')
                    //获取到菜单权限表
                    this.navlist = res.data.queryResult
                    //保存到cookie中
                    setMenu(res.data)
                    //循环遍历匹配
                    for (let i = 0; i < this.navlist.length; i++) {
                        if (this.navlist[i].parentName == '设备管理' && this.navlist[i].parentId) {
                            this.device = this.navlist[i]
                        }
                        if (this.navlist[i].parentName == '故障管理' && this.navlist[i].parentId) {
                            this.alarmMsg = this.navlist[i]
                        }
                        if (this.navlist[i].parentName == '统计报表' && this.navlist[i].parentId) {
                            this.graphs = this.navlist[i]
                        }
                        if (this.navlist[i].parentName == '配置管理' && this.navlist[i].parentId) {
                            this.resource = this.navlist[i]
                        }
                        if (this.navlist[i].parentName == '软件管理' && this.navlist[i].parentId) {
                            this.task = this.navlist[i]
                        }
                        if (this.navlist[i].parentName == '系统管理' && this.navlist[i].parentId) {
                            this.system = this.navlist[i]                            
                        }
                    }       
                })
        },
        watch: {
            //监听路径变化
            '$route.path'(a, b) {
                this.path = a
            }
        },
        computed: {
            ...mapGetters(['NavShow','Logo'])
        }
    }
</script>

<style scoped>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 100%;
        min-height: 7.6rem;
    }
    .el-menu {
        border: none;
        background-color: #5e5e5f;
    }
    .con {
        background-color: #5e5e5f;
        overflow: hidden;
        overflow-x: hidden;
        overflow-y: scroll;
        position: fixed;
        z-index: 100;
        transform: scale3d(1, 1, 1);
    }
    .iconsize {
        color: #f4f4f5;
        margin-right: 0.2rem;
    }
    .el-submenu .el-menu-item {
        min-width: 0;
    }
    .con::-webkit-scrollbar {
        display: none;
    }
    .iconbuttom {
        height: 1rem;
        width: 100%;
        position: fixed;
        z-index: 200;
    }
    .ilist {
        padding: 0.27rem;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .Layout-Nav{
        height: 100vh;
        /* transition:all 300ms ease-out; */
    }
    .Layout-Nav::-webkit-scrollbar {
        display: none;
    }
    .Layout-Nav-Con{
        width: 220px;
        height: 8vh;
        /* border-bottom:4px solid  #eaeaea; */
        border-bottom: none;
        box-sizing: border-box;
        position: fixed;
        z-index: 10;
        background-color: #0074c7;
        display: flex;
    }
    .Layout-Nav-Con-Show{
        width: 64px;
        height: 8vh;
        /* border-bottom:4px solid  #eaeaea; */
        border-bottom: none;
        box-sizing: border-box;
        position: fixed;
        z-index: 10;
        background-color: #0074c7;
    }
    .Layout-Nav-Logo{
        width: 75%;
        margin:0 auto 0 auto;
        display: block;
        height: 85%;
        padding-top:2.5%;
        padding-bottom: 2.5%;
    }
    .Layout-Nav-Logo-Show{
        width: 80%;
        display: block;
        height: auto;
        position:absolute;
	    top:0;
	    bottom:0;
	    left:0;
	    right:0;
        margin:auto;
        z-index: 10;
    }
    .Layout-Nav-Irem-Icon{
        font-size: 18px;
        margin-right: 10px;
        line-height: 50px;
    }
    /* .el-menu-item.is-active { */
    /* background-color: #4b5cc4 !important; */
    /* border-left:3px solid #ffffff;  */
    /* box-sizing:border-box !important;
    padding-left: 37px !important; */
    /* } */
    .el-menu-item:hover{
        background-color: #1f2c39 !important;
    }
    .Dashboard-Title{
        font-size:20px;
        font-weight: bold;
    }
    .Menu-Group{
        background-color: #028ce9 !important;
    }
    .but {
    font-size: 20px;
    /*margin-left: 20px;*/
    line-height: 10vh;
    color: #ffffff;
}
</style>
